import CounterValueCell from './CounterValueCell';

export default CounterValueCell;
